module.exports = __webpack_public_path__ + "static/process4-211da2b612a76897504b20ab238a72e5.png";